import { createSelector } from 'reselect';
import { creationRewardsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const creationRewardsYearsSelector = createSelector([creationRewardsSelector], (creationRewards) =>
  extractDatesFromNestedItems(
    [creationRewards.content],
    [
      {
        type: 'date',

        field: 'date',
      },
    ],
  ),
);
